import styled from "styled-components/macro";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";

/**
 * Styled Components for Historical Permits Report
 * @module PermitReportStyles
 */

/**
 * Wrapper for the MaterialTable with responsive overflow handling
 */
export const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)}px);
  max-height: calc(100% - 48px);
`;

/**
 * Breadcrumbs with Material-UI spacing support
 */
export const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

/**
 * Divider with Material-UI spacing support
 */
export const Divider = styled(MuiDivider)(spacing);
